export const AI_CONFIDENCE_PAGE_FLAG_KEY = "sf_emt_enable-ai-confidence-page";

const getEnvValue = (key: string): string => {
	const env = process.env as Record<string, string | undefined>;
	return env[key] ?? "";
};

const isQaOrLocal = (): boolean => {
	const { href } = window.location;
	return href.includes("qa") || href.includes("localhost");
};

export const getLaunchDarklyClientId = (): string =>
	isQaOrLocal() ? getEnvValue("LAUNCH_DARKLY_TEST_CLIENT_ID") : getEnvValue("LAUNCH_DARKLY_PRODUCTION_CLIENT_ID");

export const launchDarklyConfig = {
	clientSideID: getLaunchDarklyClientId(),
	reactOptions: {
		useCamelCaseFlagKeys: false,
	},
	context: {
		kind: "user",
		key: "stagefront-emt",
	},
};
